export function wymagane (inputData, allData){

  var wymagane = []



  if(inputData) {

    allData.map((data, idx) =>{

      inputData.map(nazwa => {

        if(nazwa === data.nazwa) { wymagane.push(data.longName); return null }

        else { return null }

      });

    }) 

    return wymagane

  }

  else return []

}